export const FourByFour = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="18" height="18" rx="3.5" stroke="black" />
      <line x1="9.5" y1="19" x2="9.5" y2="1.72545e-08" stroke="black" />
      <rect
        x="0.5"
        y="0.5"
        width="18.2729"
        height="18.2729"
        rx="3.5"
        stroke="black"
      />
      <line
        x1="0.295898"
        y1="9.28467"
        x2="19.2723"
        y2="9.28467"
        stroke="black"
      />
    </svg>
  );
};
